import { Check, Minus } from '@music-vine/cadence/icons';
import type React from 'react';
import { twMerge } from '@/lib/twMerge';
const TableDataContainer = ({
  className,
  children
}: {
  className?: string;
  children: React.ReactNode;
}) => <td className={twMerge('px-4 py-2 text-center font-sans text-gray-700 text-sm', className)} data-sentry-component="TableDataContainer" data-sentry-source-file="CellData.tsx">
    {children}
  </td>;
const CellData = ({
  className,
  children,
  checked,
  notApplicable
}: {
  className?: string;
  children?: React.ReactNode;
  checked?: boolean;
  notApplicable?: boolean;
}) => {
  const fullClassName = twMerge('dark:text-gray-300', className);
  if (checked) {
    return <TableDataContainer className={fullClassName}>
        <Check className="mx-auto size-4 text-gray-950 dark:text-gray-50" />
      </TableDataContainer>;
  }
  if (notApplicable) {
    return <TableDataContainer className={fullClassName}>
        <Minus className="mx-auto size-4 text-gray-500 dark:text-gray-50" />
      </TableDataContainer>;
  }
  return <TableDataContainer className={fullClassName} data-sentry-element="TableDataContainer" data-sentry-component="CellData" data-sentry-source-file="CellData.tsx">
      {children}
    </TableDataContainer>;
};
export default CellData;